<div fxLayout="column" fxFlex="100" fxLayoutGap="20px">
  <div class="container" fxLayout="column" fxFlex="100" fxLayoutGap="20px">
    <h1 class="header">Ustawienia</h1>
    <div class="content-card">
      <mat-tab-group mat-stretch-tabs="false">
        <mat-tab [label]="'Dostęp do dokumentów'"> </mat-tab>
      </mat-tab-group>
    </div>

    <ng-container>
      <app-document-permission-settings></app-document-permission-settings>
    </ng-container>
  </div>
</div>
